import { CookieConsentTrigger } from '@/features/cookie-consent';
import { CURRENT_YEAR } from '@/shared/constants/current-year';
import { INFO_EMAIL, SITE_DOMAIN } from '@/shared/constants/site';
import { FACEBOOK_URL, LINKEDIN_URL } from '@/shared/constants/social';
import Link from "next/link";
import {
  LinkedinLogoIcon,
  FacebookLogoIcon,
  AtIcon,
  PhoneIcon,
} from "@phosphor-icons/react/ssr";
import { NAVIGATION_CONFIG } from '@/shared/constants/landing/landing-navigation.constants';
import Logo from "../assets/logo.svg";
import FooterBg from "../assets/bg-img-full.svg";
import { Text } from "@/shared/ui/core";
import styles from "./landing-footer.module.scss";
import cn from "classnames";


export const LandingFooter = () => {
  return (
    <footer className={styles.root} data-template="landing-footer">
      <div className={styles.content}>
        <FooterBg className={styles.bg} />
        <div className={styles.contacts}>
          <Logo className={styles.logo} />
          <Text as="p" className={cn(styles.text, styles.description)}>
            A European logistics ecosystem where every shipment is verified,
            secure and trusted by expert community
          </Text>

          <div className={styles.links}>
            <div className={styles.links_social}>
              <Text as="p" className={styles.text}>
                Feel free to get in touch with us via phone or send us a message
              </Text>
              <div className={styles.social_icons}>
                <Link
                  href={ LINKEDIN_URL }
                  prefetch={ false }
                >
                  <LinkedinLogoIcon className={styles.icon} />
                </Link>
                <Link
                  href={ FACEBOOK_URL }
                  prefetch={ false }
                >
                  <FacebookLogoIcon className={styles.icon} />
                </Link>
              </div>
            </div>

            <div className={styles.links_info}>
              <div className={styles.col}>
                <AtIcon className={styles.col_icon} />
                <a href={`mailto:${ INFO_EMAIL }`}>{ INFO_EMAIL }</a>
              </div>
              <div className={styles.col}>
                <PhoneIcon className={styles.col_icon} />
                <a href="tel:+31103073779">+31 10 307 3779</a>
              </div>
            </div>

            <div className={styles.links_info}>
              <div className={styles.col}>
                  <Text as="p" className={styles.reg_info}>
                      { 'CarrierCheck B.V., Coolsingel 104, 3011 AG Rotterdam,\nNetherlands KVK 99610558   ×  VAT NL869060545B01' }
                  </Text>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.navigation}>
          {NAVIGATION_CONFIG.map(({ title, options }) => {
            return (
              <div key={title} className={styles.navigation_col}>
                <Text as="h3" className={styles.text}>
                  {title}
                </Text>
                <ul>
                  {options.map(({ label, href, target }) => (
                    <li key={label}>
                      <Link
                          target={ target }
                          href={href}
                      >
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
          <div className={styles.navigation_col}>
            <CookieConsentTrigger/>
          </div>
        </div>

        <div className={styles.copyright}>
          <p>© { CURRENT_YEAR } ${ SITE_DOMAIN }. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
